import React, { FC, ReactNode } from 'react'
import { SpinnerComponent } from 'Pages/landings/newLandings/common/components/Spinner'
import { Button, SpinnerWrapper } from './styled'

export interface ComponentProps {
	text: string
	type: string
	measure: string
	children?: ReactNode
	childrenLeft?: boolean
	onClick?: () => void
	className?: string
	style?: React.CSSProperties
	disabled?: boolean
	isLoading?: boolean
}

export const ButtonComponent: FC<ComponentProps> = ({
	text,
	type,
	measure,
	children,
	childrenLeft = false,
	onClick,
	className,
	disabled,
	style,
	isLoading = false,
}) => (
	<Button
		type="button"
		className={className}
		onClick={onClick}
		buttonType={type}
		measure={measure}
		disabled={disabled}
		style={style}
		isLoading={isLoading}
	>
		{childrenLeft && children ? children : null}
		{text}
		{!childrenLeft && children && children}
		{isLoading && (
			<SpinnerWrapper>
				<SpinnerComponent />
			</SpinnerWrapper>
		)}
	</Button>
)
